import axios from 'axios';

export default function getQuickBookFileUrl(config) {
  const headers = {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  const url = config.getQuickBookFileUrl;
  return dispatch => dispatch({
    type: 'QUICK_BOOK_FILE_FETCH',
    payload: axios({ method: 'get', url, headers })
  });
}


// WEBPACK FOOTER //
// ./src/actions/getQuickBookFileUrl.js